export const firebaseConfig = {
  apiKey: "AIzaSyBzX78ro1GrlkwFsbw09PVAS74cCw7oHGs",
  authDomain: "jobsrmine-sso.firebaseapp.com",
  projectId: "jobsrmine-sso",
  storageBucket: "jobsrmine-sso.firebasestorage.app",
  messagingSenderId: "206548389126",
  appId: "1:206548389126:web:d98d9c9875d7ad149c6287",
  measurementId: "G-KWJ8200W4W",
};
